(function(){
  function initAtelier(root){
    var section = root.querySelector('[data-vp-atelier]');
    if(!section || section.dataset.vpInit) return;
    section.dataset.vpInit = '1';

    /* ---- scroll reveal ---- */
    var targets = section.querySelectorAll('.vp-reveal');
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(!('IntersectionObserver' in window) || reduce){
      targets.forEach(function(el){ el.classList.add('in'); });
    } else {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      }, {threshold:0, rootMargin:'0px 0px -8% 0px'});
      targets.forEach(function(el){ io.observe(el); });
      setTimeout(function(){ targets.forEach(function(el){ el.classList.add('in'); }); }, 3800);
    }

    /* ---- gentle parallax drift on the two images ---- */
    if(reduce) return;
    var parallax = [].slice.call(section.querySelectorAll('[data-vp-parallax]'));
    if(!parallax.length) return;
    var ticking = false;
    function update(){
      var vh = innerHeight;
      parallax.forEach(function(el){
        var speed = parseFloat(el.dataset.vpParallax) || 0.06;
        var r = el.getBoundingClientRect();
        var center = r.top + r.height / 2 - vh / 2;
        var img = el.querySelector('img');
        if(img) img.style.transform = 'translateY(' + (center * -speed).toFixed(1) + 'px) scale(1.08)';
      });
      ticking = false;
    }
    addEventListener('scroll', function(){
      if(!ticking){ requestAnimationFrame(update); ticking = true; }
    }, {passive:true});
    update();
  }
  function boot(){ initAtelier(document); }
  if(document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function(e){ initAtelier(e.target); });
})();